import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentJointReenterVerifyPhoneData,
  type EnrollmentJointReenterVerifyPhoneSubmitOutput,
  type EnrollmentJointVerifyPhoneContinueApplicationOutput,
} from '../../../../models/enrollment/joint/reenter-verify-phone'

export const getEnrollmentJointReenterVerifyPhoneDataMock: EnrollmentJointReenterVerifyPhoneData = {
  nextStep: 'VERIFY_PHONE',
  error: null,
  phone: {
    countryPhoneCode: '+1',
    phoneNumber: '1234567890',
  },
}

export const submitEnrollmentJointReenterVerifyPhoneDataMock: EnrollmentJointReenterVerifyPhoneSubmitOutput = {
  nextStep: 'SESSION_RESTORED',
  error: null,
  phone: {
    countryPhoneCode: '+1',
    phoneNumber: '1234567890',
  },
}

export const submitEnrollmentJointResendReenterVerifyPhoneDataMock: EnrollmentJointReenterVerifyPhoneSubmitOutput = {
  nextStep: 'VERIFY_PHONE',
  error: null,
  phone: {
    countryPhoneCode: '+1',
    phoneNumber: '1234567890',
  },
}

export const submitEnrollmentJointReenterVerifyPhoneOtpDataMock: EnrollmentJointVerifyPhoneContinueApplicationOutput = {
  errors: [],
  isError: false,
  activePerson: {
    path: '/enrollment/joint/next-step',
  },
}

export const mockGetEnrollmentJointReenterVerifyPhoneData = graphql.mutation(
  'getEnrollmentJointReenterVerifyPhoneData',
  () => {
    return HttpResponse.json({ data: { enterApplication: getEnrollmentJointReenterVerifyPhoneDataMock } })
  },
)

export const mockSubmitEnrollmentJointReenterVerifyPhoneData = graphql.mutation(
  'submitEnrollmentJointReenterVerifyPhoneData',
  () => {
    return HttpResponse.json({ data: { enterApplication: submitEnrollmentJointReenterVerifyPhoneDataMock } })
  },
)

export const mockSubmitEnrollmentJointResendReenterVerifyPhoneData = graphql.mutation(
  'submitEnrollmentJointResendReenterVerifyPhoneData',
  () => {
    return HttpResponse.json({ data: { enterApplication: submitEnrollmentJointResendReenterVerifyPhoneDataMock } })
  },
)

export const mockSubmitEnrollmentJointReenterVerifyPhoneOtpData = graphql.mutation(
  'submitEnrollmentVerifyPhoneData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentJointReenterVerifyPhoneOtpDataMock } })
  },
)

export const mockEnrollmentJointReenterVerifyPhone = [
  mockGetEnrollmentJointReenterVerifyPhoneData,
  mockSubmitEnrollmentJointReenterVerifyPhoneData,
  mockSubmitEnrollmentJointResendReenterVerifyPhoneData,
  mockSubmitEnrollmentJointReenterVerifyPhoneOtpData,
]
